import { useScopedAppFlagStore } from '@frontend/scope';
import { useLocalStorage } from '@frontend/web-storage';

const LOCALSTORAGE_KEY = 'weave.scheduler-v3-ui-ff-override';

export const useScheduleV3Override = () => {
  const [isSchedulerV3FFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  return { isSchedulerV3FFOverride };
};

export const useGetSchedulerV3FeatureFlagDetails = () => {
  const { isSchedulerV3FFOverride } = useScheduleV3Override();

  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const hasSchedulerV3UI = getFeatureFlagValue('scheduler-v3-ui', 'ALL');

  return { isScheduleV3FlagEnabled: hasSchedulerV3UI || !!isSchedulerV3FFOverride };
};
